<template>
    <div class="modal_cont ismsp_cert_modal">
        <div class="modal_header">
            <a href="#none" @click="closeModal" class="btn_close">{{ t.closeLabel }}</a>
        </div>

        <div class="modal_content">
            <figure class="cert_image_wrap">
                <img :src="certImage" alt="GS리테일 온라인 서비스 ISMS-P 인증서">
            </figure>
        </div>
    </div>
</template>

<script>
import modal from "@/utils/popupModal";
import certImage from "@/assets/images/sub/gsrsu03010101/ismsp_certificate_gsretail2021.jpg";
import Buttons from "@/components/Buttons.vue";

export default {
    name: "gsrsu03030501",
    components: {
        Buttons
    },
    data() {
        return {
            certImage,
            langData: {
                ko: {
                    closeLabel: "닫기",
                },
                en: {
                    closeLabel: "Close"/* 260708 번역 */,
                },
            }
        };
    },
    computed: { 
        t() { 
            // langData가 없거나, 해당 언어 데이터가 없을 경우를 모두 대비
            const data = this.langData[(document.querySelector('.language button.current')?.textContent.trim().toLowerCase()||'ko')] || this.langData.ko;
            return data || {}; 
        } 
    },
    methods: {
        closeModal(event) {
            modal.close(event.currentTarget);
        }
    }
};
</script>

<style scoped>
.ismsp_cert_modal .modal_content { text-align: center; }
.cert_image_wrap { margin: 0; }
.cert_image_wrap img { display: block; width: 100%; max-width: 900px; margin: 0 auto; }
</style>
